/**
 * 窗口内新消息提示条（18c2b，桌面专属）。
 *
 * 旧版「PC 端提醒 → 窗口内弹窗提示」（in_app_popup）的 Web 等价物：页面在前台
 * 但用户正开着别的会话时，系统通知那条通道刻意不弹（notifyDecision 的
 * `foreground` 档），改由右下角这一叠提示条承担。
 *
 * 组件只负责画 + 转发点击：要不要出、出什么由 `shouldPopupInApp` 判定，队列/超时/
 * 提示音在 `store/notifyPopupState`。`isMobile` 这里再挡一道——判定时读的是当批
 * 回流那一刻的断点，提示条还在屏上时用户可能把窗口缩成了移动布局。
 */
import { useGlobal } from '~/store/useGlobal';
import { avatarStyle } from '~/chat/avatarColor';
import { notifyPopups } from '~/store/notifyPopup';
import { selectNotifyPopups } from '~/store/notifyPopupState';
import styles from './notifyPopups.module.scss';
import { IconClose } from '~/ui/icons';

export function NotifyPopups() {
  const items = useGlobal(selectNotifyPopups);
  const isMobile = useGlobal((s) => s.layout.isMobile);
  if (isMobile || items.length === 0) return null;
  return (
    <div className={styles.stack} data-testid="notify-popups">
      {items.map((item) => (
        <div key={item.id} className={styles.card} data-testid="notify-popup" role="status">
          <button
            type="button"
            className={styles.open}
            data-testid="notify-popup-open"
            data-key={item.conversationKey}
            onClick={() => notifyPopups().activate(item.id)}
          >
            <span className={styles.avatar} aria-hidden="true" style={avatarStyle(item.title)}>
              {item.icon ? (
                <img
                  className={styles.avatarImg}
                  src={item.icon}
                  alt=""
                  onError={(e) => {
                    // 加载失败就露出底下的首字占位（头像已在会话列表里展示过，走 HTTP 缓存）
                    e.currentTarget.style.display = 'none';
                  }}
                />
              ) : null}
              <span className={styles.avatarChar}>{item.title.slice(0, 1)}</span>
            </span>
            <span className={styles.main}>
              <span className={styles.title}>{item.title}</span>
              <span className={styles.body}>{item.body}</span>
            </span>
            {item.unread > 1 && (
              <span className={styles.badge} data-testid="notify-popup-unread">
                {item.unread > 99 ? '99+' : item.unread}
              </span>
            )}
          </button>
          <button
            type="button"
            className={styles.close}
            data-testid="notify-popup-close"
            aria-label="关闭提示"
            onClick={() => notifyPopups().dismiss(item.id)}
          >
            <IconClose class={styles.closeGlyph} />
          </button>
        </div>
      ))}
    </div>
  );
}
